import type { IComboBoxOption } from '@fluentui/react';

const lang = JSON.parse(localStorage.getItem('userLanguagePreferences'));

export const POOL_ALL_KEY = 0;          
export const POOL_ALL_LABEL = lang === 'fr' ? 'Toutes' : 'All';    
export const POOL_ALL_WIRE = 'AllPools';
export type SelectedKey = string | number;

export function withAllFirst(options: IComboBoxOption[]): IComboBoxOption[] {
  const rest = (options ?? [])
    .filter(o => o?.key !== POOL_ALL_KEY)
    .sort((a, b) => (a.text || '').localeCompare(b.text || ''));
  return [{ key: POOL_ALL_KEY, text: POOL_ALL_LABEL }, ...rest];
}

export function toggleAllMulti(
  clicked: IComboBoxOption,
  current: SelectedKey[],
  allOptions: IComboBoxOption[]
): SelectedKey[] {
  const allPoolKeys = (allOptions ?? []).filter(o => o.key !== POOL_ALL_KEY).map(o => o.key);

  if (clicked.key === POOL_ALL_KEY) {
    return current.includes(POOL_ALL_KEY) ? [] : [POOL_ALL_KEY, ...allPoolKeys];
  }

  const next = new Set(current);
  next.has(clicked.key as any) ? next.delete(clicked.key as any) : next.add(clicked.key as any);

  next.delete(POOL_ALL_KEY);

  const only = [...next];
  return only.length === allPoolKeys.length && allPoolKeys.length != 1 ? [POOL_ALL_KEY, ...only] : only;
}

export function serializePools(
  selection: SelectedKey[],
  allOptions: IComboBoxOption[]
): string {
  const allPoolKeys = (allOptions ?? []).filter(o => o.key !== POOL_ALL_KEY).map(o => o.key);
  const only = (selection ?? []).filter(k => k !== POOL_ALL_KEY);
  return only.length === allPoolKeys.length && allPoolKeys.length != 1 ? POOL_ALL_WIRE : only.join(', ');
}
